// extracted by mini-css-extract-plugin
module.exports = {"block":"MobileCoursesList_block__lkX4U","button":"MobileCoursesList_button__grHk5","label":"MobileCoursesList_label__2lojb"};